import { Injectable } from '@angular/core';
import { DzGridConstants } from '@blk/daisy/util';
import { ModelFamiliesUtil } from '@ddt-web/models-screener';
import { StoreService } from '@ddt-web/store-service';
import { Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { ModelsBrowseStoreConfig } from '../config/store.config';
import { ModelFamily } from '../models/model-family.interface';

@Injectable({
	providedIn: 'root'
})
export class ModelsBrowseModelsMappingService {

	constructor(
		private storeService: StoreService
	) { }

	/**
	 * Gets models list for given family id and group id
	 *
	 * @param familyId family id.
	 * @param groupId group id.
	 * @return an observable of models list.
	 */
	public getModelsList(familyId: string, groupId: string): Observable<string[]> {
		return this.storeService.selectById(ModelsBrowseStoreConfig.families, familyId)
			.pipe(first(family => !!family),
				map(family => {
					const modelFamily: Array<ModelFamily> = Object.values(family);
					const familyModelsPerCategory = ModelFamiliesUtil.generateFamilyIdModelsMapping(modelFamily);
					return familyModelsPerCategory?.[groupId]?.[familyId] || [];
				}));
	}

	public setModelIdsAndConfigForComponentData(modelIdsList: string[]): { modelIds: Observable<string[]>; config: Object } {
		// Set Model Ids for preparing component data for holdings table body
		if (window.innerWidth < DzGridConstants.BREAKPOINTS.sm) {
			return {
				modelIds: of([modelIdsList[0]]),
				config: {
					rightColClass: 'col-14',
					leftColClass: 'col-10'
				}
			};
		}
		else if (window.innerWidth < DzGridConstants.BREAKPOINTS.lg) {
			return {
				modelIds: of([modelIdsList[0]]),
				config: {
					rightColClass: 'col-12',
					leftColClass: 'col-12'
				}
			};
		}
		return {
			modelIds: of(modelIdsList),
			config: {
				rightColClass: 'col-6',
				leftColClass: 'col-18'
			}
		};
	}
}
